import React, { useState } from 'react'
import Stack from '@mui/material/Stack'
import LogsComponent from '../../../../components/Logs/LogsComponent'
import { SectionHeader } from './SectionKit'

const NotesSection = ({ vehicleID }) => {
  const [openComment, setOpenComment] = useState(false)
  return (
    <Stack spacing={1.5}>
      <SectionHeader
        title="Notes"
        caption="Free-text notes and activity recorded against this vehicle"
      />
      <LogsComponent
        targetId={vehicleID}
        targetType="vehicle"
        hideTitle
        allowCreateLog
        openComment={openComment}
        setOpenComment={setOpenComment}
      />
    </Stack>
  )
}

export default NotesSection
